import { TelevisionIcon } from './TelevisionIcon';

/**
 * author: Google
 * id 1B699A99-578E-450C-9523-934F4D281F72
 * name television
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const TvIcon = TelevisionIcon;
export default TvIcon